'use client';

import { useQuery } from '@tanstack/react-query';
import useIsMainnet from '../useIsMainnet';
import { getRetryDelayFn } from '../../utils/query/retryDelay';

type SUSDE_API_RESPONSE = {
	stakingYield: {
		value: number;
	};
};

export const useSusdeFetch = () => {
	const isMainnet = useIsMainnet();

	return useQuery({
		queryKey: ['susdeYield'],
		queryFn: async (): Promise<SUSDE_API_RESPONSE> => {
			const requestUrl = `https://ethena.fi/api/yields/protocol-and-staking-yield`;

			const response = await fetch(requestUrl);
			if (!response.ok) {
				throw new Error(`Failed to fetch sUSDe metrics: ${response.status}`);
			}
			return response.json();
		},
		enabled: isMainnet,
		staleTime: 10 * 60 * 1000, // 10 minutes
		retryDelay: getRetryDelayFn(2000),
		retry: 3,
	});
};
